import { IgetSalesMatchingAPIBody } from 'api/endpoints/salesMatching/salesMatching.response.interface';
import { IInitialSalesMatchingState } from 'interfaces/salesMatching.interface';
import { ITableColumnsSelectOrderState } from 'interfaces/tables.interface';

const body: IgetSalesMatchingAPIBody = {
  order: ['count', 'DESC'],
  index: 0,
  limit: 10,
  filter: {
    client_id: {
      value: '',
      operator: '=',
    },
  },
};

export const initialSalesColumnsOrder: Record<string, ITableColumnsSelectOrderState> = {
  reference: { show: true, required: false, order: 1 },
  product_description: { show: true, required: false, order: 2 },
  color_code: { show: true, required: false, order: 3 },
  color: { show: true, required: false, order: 4 },
  size: { show: true, required: false, order: 5 },
  client_ean: { show: true, required: false, order: 6 },
  ean: { show: false, required: false, order: 7 },
  season: { show: true, required: false, order: 8 },
  count: { show: true, required: false, order: 9 },
  family: { show: false, required: false, order: 13 },
  division: { show: false, required: false, order: 14 },
  gender: { show: false, required: false, order: 15 },
  brand_name: { show: false, required: false, order: 16 },
};

const initialSalesMatchingState: IInitialSalesMatchingState = {
  salesMatchingBodyFetch: body,
  getSalesMatchingItems: () => Promise.resolve(false),
  salesMatchingItems: {
    count: 0,
    total: 0,
    data: [],
  },
  salesMatchingItemsSelected: [],
  setSalesMatchingItemsSelected: () => {},
  isLoadingSalesMatchingItems: false,
  setSortBy: () => Promise.resolve(false),
  salesMatchingToUpdateBody: null,
  salesMatchingToUpdate: [],
  addToSalesMatchingToUpdate: () => Promise.resolve(false),
  isLoadingAddToSalesMatchingToUpdate: {
    saleId: null,
    isLoading: false,
  },
  options: [],
  matchSale: () =>
    Promise.resolve({
      success: false,
    }),
  matchSaleSimilarItems: () => Promise.resolve(false),
  cancelMatchSale: () => {},
  unmatchSales: () => Promise.resolve(false),
  isLoadingUnmatchSales: false,
  searchOnCatalogItems: () => Promise.resolve(false),
  handlePagination: () => Promise.resolve(false),
  setOwnClientProduct: () => Promise.resolve(false),
  isLoadingSetOwnClientProduct: false,
  // Columns
  columnsOrder: initialSalesColumnsOrder,
  moveColumnsOrder: () => {},
  checkColumn: () => {},
};

export default initialSalesMatchingState;
